import {SidebarSuggestedWorkflows as Component} from '@github-ui/code-view-sidebar/components/SidebarSuggestedWorkflows'
import type {SidebarSuggestedWorkflowsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarSuggestedWorkflows({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'suggestedWorkflows', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/suggested-workflows`)
      return (await r.json()) as SidebarSuggestedWorkflowsResponse
    },
  })

  if (!data) return null
  return <Component {...data} />
}
